const __filename = "/app/views/pages/reviews.js", __dirname = "/app/views/pages";
document.addEventListener('DOMContentLoaded', () => {
  // Handle "read more" truncation buttons.
  const readMoreBtns = document.querySelectorAll('.js__readMore')
  for (const btn of readMoreBtns) {
    btn.addEventListener(
      'click',
      function () {
        this.parentElement.querySelector('.js__truncated').style.display = 'none'
        this.parentElement.querySelector('.js__untruncated').style.display = 'block'
        this.style.display = 'none'
      },
      { once: true }
    )
  }
})
